import { getQuerySelector } from '@redux-requests/core'
import { createSelector } from 'reselect'
import { EActionType } from '../actions'
//const authTokenQuerySelector: any = getQuerySelector({ type: EActionType.FETCH_AUTH_TOKEN_SSO })

const ssoSelector: any = getQuerySelector({
	type: EActionType.FETCH_AUTH_TOKEN_SSO,
})

export let user: any = {}
// export const isAuthenticatedSelector: any = createSelector(authTokenQuerySelector, (authTokenQuery: any) =>
// { console.log(authTokenQuery.data)
// 	user = authTokenQuery.data
// 	return authTokenQuery.data !== null && authTokenQuery.data !== '' ? true : false
// })

// export const getAuthDataSelector: any = createSelector(authTokenQuerySelector, (authTokenQuery: any) => {
// 	user = authTokenQuery.data

// 	return {
// 		isAuthenticated: user ? true : false,
// 		user: authTokenQuery.data,
// 	}
// })

export const getSSOUserSelector: any = createSelector(ssoSelector, () => {
	return {
		user: 'test',
	}
})
